import { render } from "./calendar-small.svg?vue&type=template&id=22d40d58?inline"
const script = {}
script.render = render

export default script